import { render, staticRenderFns } from "./ReturnModal.vue?vue&type=template&id=72415a53&scoped=true"
import script from "./ReturnModal.vue?vue&type=script&lang=js"
export * from "./ReturnModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72415a53",
  null
  
)

export default component.exports